import React, { FC } from 'react'

import { IconContactlessPaymentProps } from './IconContactlessPayment.types'
import * as Styled from './styles/IconContactlessPayment.style'

import { nonThemeableRules } from '../../ruleSet'

const IconContactlessPayment: FC<IconContactlessPaymentProps> = ({
  size = nonThemeableRules.defaultSize as number as IconContactlessPaymentProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconContactlessPaymentProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path d='M117 9.77a4 4 0 0 0-6.9 4 131.14 131.14 0 0 1 0 132.38 4 4 0 1 0 6.9 4 139.16 139.16 0 0 0 0-140.38z' />
        <path d='M82.65 22.49A4 4 0 0 0 81.33 28a99.07 99.07 0 0 1 0 104 4 4 0 1 0 6.82 4.18 107 107 0 0 0 0-112.39 4 4 0 0 0-5.5-1.3zM53.71 36.83a4 4 0 0 0-1.11 5.55 67.59 67.59 0 0 1 0 75.28 4 4 0 1 0 6.65 4.44 75.56 75.56 0 0 0 0-84.16 4 4 0 0 0-5.54-1.11zM24.32 51.35a4 4 0 0 0-.55 5.65 36.41 36.41 0 0 1 0 46.1 4 4 0 1 0 6.18 5.08A44.43 44.43 0 0 0 30 51.9a4 4 0 0 0-5.68-.55z' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconContactlessPayment
